// What the community does, in three verbs.
import { ArrowUpRight, Books, Scales, Toolbox } from "@phosphor-icons/react";
import { Link } from "react-router";

import { SectionHead } from "../../ui/Section";

const PILLARS = [
  {
    n: "01",
    Icon: Books,
    title: "Educate",
    body: "Plain guides for organisations and individuals on securing access in the age of AI: what to connect, what to never hand over, what to ask a vendor.",
    to: "/learn",
    cta: "Secure your access",
  },
  {
    n: "02",
    Icon: Toolbox,
    title: "Equip",
    body: "Free tools and open formats: portable workflows, a validator, a meter for what a prompt might cost, and a calculator for what guards save.",
    to: "/tools",
    cta: "Use the free tools",
  },
  {
    n: "03",
    Icon: Scales,
    title: "Hold to account",
    body: "A public Charter and a Danger Scale that AI companies can be measured against, argued in the open and signed by the people they serve.",
    to: "/charter",
    cta: "Read the Charter",
  },
];

export function Pillars() {
  return (
    <section className="wrap py-20 sm:py-28">
      <SectionHead kicker="§ What we do" title={<>An all-hands effort. Not a vendor's promise.</>}>
        AI will arrive in every job and every organisation. Whether it arrives on the public's terms depends on how many of us turn up.
      </SectionHead>
      <div className="mt-12 grid gap-4 md:grid-cols-3">
        {PILLARS.map((p) => (
          <Link key={p.n} to={p.to} className="card group relative flex flex-col p-6 transition-transform hover:-translate-y-1 sm:p-7">
            <div className="flex items-center justify-between">
              <p.Icon weight="duotone" className="h-9 w-9 text-ink" aria-hidden />
              <span className="font-mono text-sm text-ink3">{p.n}</span>
            </div>
            <h3 className="mt-8 font-display text-3xl font-bold tracking-tight">{p.title}</h3>
            <p className="mt-3 flex-1 text-[15.5px] leading-relaxed text-ink2">{p.body}</p>
            <span className="mt-6 inline-flex items-center gap-1.5 text-[14.5px] font-semibold text-ink group-hover:text-signal">
              {p.cta} <ArrowUpRight weight="bold" className="h-4 w-4" aria-hidden />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
